import React, { useState, useEffect } from "react";
import axios from "axios";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import defaults from "../constants/defaults";
import DemoForm from "./DemoForm";
import {ContentItem} from "./ContentItem";
import { SurveyContainer } from "./SurveyContainer";
import {Home} from "./Home";
import OcationAds from "./OcationAds/OcationsAds";
import {CategoryItem} from "./OcationAds/AdItem";
import { OcationContentItem } from "./OcationAds/OcationContentItem";
import ReqCredit from "./ReqCredit/ReqCredit";
import Politicas from "./ReqCredit/Politicas";
import { NewDescription } from "./News/NewDescription";
import { NewContent } from "./News/NewContent";
import { GoogleAdsSense } from "./GoogleAdsSense";
import { InputCode } from "./InputCode/InputCode";
import { AudioPodcast } from "./AudioPodcast";
import { BannerPromotional } from "./BannerPromotional";
import {NewVerifyCel} from "./NewVerifyCel"
import CutPasteURL from "./CutPasteURL/CutPasteURL";
import { TyCComponent } from "./TyC";
import { Loading } from "./Loading";
import crypto from "crypto-js";


const App = () => {
  const [loading, setLoading] = useState(true);
  const [ap, setAp] = useState(null);
  const [deviceId, setDeviceId] = useState(null);
  const [so, setSo] = useState("");
  const [user, setUser] = useState(null);
  const [solicited_code, setSolicited_code] = useState(false);
  const [closeBannerMain, setCloseBannerMain] = useState(false);
  const [solicited_phone, setSolicited_phone] = useState(false);
  const [solicited_cutandpaste, setSolicited_cutandpaste] = useState(false);
  const [urlPost, setUrlPost] = useState("");
  const [usingBrowser, setUsingBrowser] = useState(false);
  const [test, setTest] = useState(false);
  const [check, setCheck] = useState(false);
  const [tyc, setTyc] = useState('');
  const [ip, setIp] = useState("");
  const [port, setPort] = useState("");

  useEffect(() => {
    const urlString = window.location.href;
    const url = new URL(urlString);
    const res_ = url.searchParams.get("res");
    const userurl_ = url.searchParams.get("userurl");
    if(res_ && res_ === 'success') {
      console.log('redirect', userurl_);
      let ur = userurl_ ? userurl_ : 'https://www.google.com';
      window.location.href = ur ;
    } else {
      _getAp();
    }
  }, []);

  const _getAp = async () => {
    const urlString = window.location.href;
    const userAgent = window.navigator.userAgent;
    const url = new URL(urlString);
    const test_ = url.searchParams.get("test") ? Boolean(url.searchParams.get("test")) : false;
    const port_ = url.searchParams.get("uamport");
    const ip_ = url.searchParams.get("uamip");
    setPort(port_ ? port_ : '');
    setIp(ip_ ? ip_ : '');
    setTest(test_);
    setUsingBrowser(url.searchParams.get("browser") ? true : false);
    setSo(userAgent.includes("iPhone") || userAgent.includes("iPad")  ? "iPhone" : "Android");
    setUrlPost(url.searchParams.get("post") ? url.searchParams.get("post") : "");

    let deviceId = url.searchParams.get("mac") || url.searchParams.get("id") || defaults.DeviceID;
    deviceId = deviceId.replace(/:/g, "");
    deviceId = deviceId.replace(/-/g, "");
    console.log("deviceId", deviceId);

    let apMac =
      url.searchParams.get("Called-Station-Id") ||
      url.searchParams.get("apmac") || url.searchParams.get("called");
    let status = urlString.includes("status") ? url.searchParams.get("status") : "";
    
    if(url.searchParams.get("carry_apmac")) {
      apMac = url.searchParams.get("carry_apmac")
    } else {
      if(!apMac) {
        apMac = defaults.AccessPointID;
      } else {
        apMac = decodeURIComponent(apMac);
      }
        apMac = apMac.replace(/:/g, "");
        apMac = apMac.replace(/-/g, "");
    }
   
    
    try {
      const res = await axios.get("/aps", {
        params: {
          apMac,
        }
      });
      if(!res.data.ap_mac) {
        setLoading(false);
        setAp(null);
        return;
      }
      const ap = res.data;
      if(ap && !test_) {
        postAccess(ap, deviceId);
      }
      if(status && status == 1) { 
        _getOpiInfo(ap, url);
      }

      let user = {};
      let askPhone = false;
      const tyc_ = await _getTyC(ap.ap_publisherID);

      if(ap.ap_askphone) {
         let userCode = await getSharedfiUserCode(deviceId.replace(/:/g, ""));
         askPhone = userCode ? false : true;
      } else {
        user = await getInfoUsereg(deviceId.replace(/:/g, ""))
      }
      const solicitacode = await _getAcceesCode(ap);
      setAp(ap);
      setDeviceId(deviceId);
      setUser(user);
      setSolicited_code(solicitacode);
      setSolicited_phone(askPhone);
      setSolicited_cutandpaste(ap ? ap.ap_copypasteurl : false);
      setTyc(tyc_);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const postAccess = async (ap, deviceId) => {
    try {
      const fields = {
        AccessPointID: ap.ap_mac,
        LocationID: Number(ap.ap_locationid),
        DeviceID: deviceId,
        CampaignID: 0,
        MediaType: "landing"
      };
      if(!test) { 
        await axios.post("/impressions", { fields });
      }
    } catch (err) {
      console.log("error posting access impression");
    }
  }

  const _getTyC = async (publisher_id) => {
    try {
      const {data} = await axios.get('/tyc',{params: {publisher_id : Number(publisher_id)}});
      return data;
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  const getSharedfiUserCode = async (id) => {
    try {
      let resp = await axios.get(`/sharedfi/code`, {
        params: {
          device_id: id,
        },
      });

      return resp.data.ok;
    } catch (error) {
      console.error("error: ", error);
      return false;
    }
  };

  const getInfoUsereg = async (id) => {
    try {
      let resp = await axios.get(`/userReg`, {
        params: {
          id,
        },
      });
      return resp.data.user;
    } catch (error) {
      console.error("error: ", error);
      return {};
    }
  };

  const _getAcceesCode = async(ap) => {
    try {
      let resp = await axios.get(`/access_code`, {
        params: {
          ap_mac: ap.ap_mac
        }
      })
      return resp.data.ok;
    } catch (error) {
      return false;
    }
  }

  const _getPassPortal = () => {
    return _passPortalAruba;
  };

  const _passPortalAruba = async (ap, campaign, deviceId, rtb) => {    
    let urlPortal = "https://securelogin.hpe.com/cgi-bin/login";   
    if(ap && campaign && deviceId && !test) {
      await _onPost(ap, campaign, deviceId);
    } else {
      _postAccessVerify();
    }
    let redirecturl = "https://wwww.google.com";
    if(rtb) {
      redirecturl = rtb.urlredirect;
    } else {
      if(campaign) {
        redirecturl = so === "iPhone" ? campaign.RedirectURL_iphone ? campaign.RedirectURL_iphone : campaign.RedirectURL : campaign.RedirectURL;
      }
    }

    if(ap && ap.ap_type.toLowerCase() === "aruba-instanon" && urlPost) {
      console.log(urlPost)
      urlPortal = 'https://' + urlPost + '/cgi-bin/login';
    }

    const urlString = window.location.href;
    const url = new URL(urlString);
    const port_ = url.searchParams.get("uamport");
    const ip_ = url.searchParams.get("uamip");

    if(ap && ap.ap_type.toUpperCase() === "TELTONIKA" && port_ && ip_) {
      console.log("ap Teltonika type entro", ap);
      const md5Password = crypto.MD5( '1234567890' + 'syner123$').toString();

      var form = document.createElement("form");
      form.setAttribute("name", "weblogin_form");
      form.setAttribute("action", `http://${ip_}:${port_}/logon`); 
      form.setAttribute("method", "GET");
      
      var hiddenField2 = document.createElement("input");
      hiddenField2.setAttribute("type", "hidden");
      hiddenField2.setAttribute("name", "command"); 
      hiddenField2.setAttribute("value", "login");
      form.appendChild(hiddenField2);

      var hiddenField3 = document.createElement("input");
      hiddenField3.setAttribute("type", "hidden");
      hiddenField3.setAttribute("name", "username");
      hiddenField3.setAttribute("value", "wavemax");
      form.appendChild(hiddenField3);

      var hiddenField4 = document.createElement("input");
      hiddenField4.setAttribute("type", "hidden");
      hiddenField4.setAttribute("name", "password");
      hiddenField4.setAttribute("value", md5Password);
      form.appendChild(hiddenField4);

      var hiddenField5 = document.createElement("input");
      hiddenField5.setAttribute("type", "hidden");
      hiddenField5.setAttribute("name", "userurl");
      hiddenField5.setAttribute("value", redirecturl);
      form.appendChild(hiddenField5);

      document.body.appendChild(form);
      form.submit();
    } else {

      var form = document.createElement("form");
      form.setAttribute("name", "weblogin_form");
      form.setAttribute("action", urlPortal);
      form.setAttribute("method", "POST");
  
      var hiddenField2 = document.createElement("input");
      hiddenField2.setAttribute("type", "hidden");
      hiddenField2.setAttribute("name", "cmd");
      hiddenField2.setAttribute("value", "authenticate");
      form.appendChild(hiddenField2);
  
      var hiddenField3 = document.createElement("input");
      hiddenField3.setAttribute("type", "hidden");
      hiddenField3.setAttribute("name", "user");
      hiddenField3.setAttribute("value", "soriana");
      form.appendChild(hiddenField3);
  
      var hiddenField4 = document.createElement("input");
      hiddenField4.setAttribute("type", "hidden");
      hiddenField4.setAttribute("name", "password");
      hiddenField4.setAttribute("value", "123456789");
      form.appendChild(hiddenField4);
      // redirect url
      var hiddenField5 = document.createElement("input");
      hiddenField5.setAttribute("type", "hidden");
      hiddenField5.setAttribute("name", "url");
      hiddenField5.setAttribute("value", redirecturl);
      
      form.appendChild(hiddenField5);
      document.body.appendChild(form);
      form.submit();
    }


  };

  const _onPost = async (ap, campaign, deviceId) => {
    try {
      const fields = {
        AccessPointID: ap.ap_mac,
        LocationID: Number(ap.ap_locationid),
        DeviceID: deviceId,
        CampaignID: campaign.CampaignID,
        MediaType: "post"
      };
      const {data} = await axios.post("/impressions", { fields });
      if(campaign.CampaignID > 0) {
        _postBalance(campaign, "post", '', data);
      }
    } catch (err) {
      console.log("error posting onPost impression");
    }
  };

  const _postAccessVerify = async() => {
    try {
      console.log("post access verify");
    } catch (error) {
      console.error(error);
    }
  }

  const _postBalance = async(campaign, impression_type, ad_type, ids) => {
    try {     
      if(!campaign.flag_default) {
        const fields = {
          advertiser_id: Number(campaign.AdvertiserID),
          publisher_id: Number(ap.ap_publisherID),
          impression_type,
          campaign_id: campaign.CampaignID,
          ad_type: ad_type ? ad_type : "campaign",
          ids: campaign.ids ? campaign.ids : "",
          ap_mac: ap.ap_mac,
          impressionids: ids ? ids : []
        }
        if(!test) {
          await axios.post("/balance", {
            fields
          });

        }
      } else {
        console.log("is default", impression_type);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const _getOpiInfo = (ap, url) => {
    const params = ["carry_parameter1", "carry_parameter2", "carry_parameter3", "carry_parameter4", "carry_parameter5"];
    const ap_mac = url.searchParams.get("carry_apmac");
    // 
    const deviceID = url.searchParams.get("id").replace(/:/g, '');
    const campaignid = url.searchParams.get("carry_campaignid");
    let answers = [];
    for (const param of params) {
      let answer = url.searchParams.get(param);
      if(answer) {
        answers.push({
          param: param.split("_")[1],
          answer
        });
      }
    }
    _postOpi(ap, deviceID, campaignid, answers);
  }

  const _postOpi = async(ap, deviceID, campaignId, answers) => {
    try {
      const fields = {
        AccessPointID: ap.ap_mac,
        LocationID: Number(ap.ap_locationid),
        DeviceID: deviceID,
        CampaignID: campaignId,
        MediaType: "opi"
      };
      const fieldsOpi = {
        id: deviceID,
        CampaignID: campaignId,
        ap_mac: ap.ap_mac,
        answers: answers
      }
      if(!test) {
        await axios.post("/impressions", { fields });
        await axios.post("/opi",{ fields: fieldsOpi } ) 
      }
      _passPortalAruba(ap, {CampaignID: campaignId}, deviceID);
    } catch (err) {
      console.log("error posting onPost impression");
    }
  }

  const _renderTyC = () => {
    if(tyc && !check) {
      return tyc.enabled;
    } 
    return false;
  }

  const passPortal = _getPassPortal();

  return(
    <Router>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      {
       loading ? <Loading /> : ap ? solicited_code ? <InputCode user={user} solicitCode={(valid)  => {
          if(valid) {
            setSolicited_code(false);
          }
        }} /> : (!usingBrowser && solicited_cutandpaste) ? <CutPasteURL ap={ap}/> : solicited_phone ? <NewVerifyCel ap={ap} passPortal={() => passPortal()} deviceId={deviceId} /> : 
        _renderTyC() ? <TyCComponent tyc={tyc} check={() => setCheck(true)}/> : !closeBannerMain ? <BannerPromotional ap={ap} 
        deviceId={deviceId} passPortal={passPortal} test={test}
        closeBannerMain={(close) => setCloseBannerMain(close)}/> : (
      
      <Switch>

        <Route
          path={`/`}
          component={() => (
            <Home 
              ap={ap} 
              deviceId={deviceId} 
              location={location} 
              passPortal={passPortal} 
              userReg={user}
              test={test}
              postBalance={(c, it, ids) => _postBalance(c, it, '', ids)} />
          )}
          exact
        />
        <Route path={`/form`} component={DemoForm} exact />
        
        
        <Route 
          path={`/content`}
          exact 
          component={(history) => (
            <ContentItem 
              history={history} 
              passPortal={passPortal} 
              test={test} postBalance={(c, it, ids) => _postBalance(c, it, '', ids)}  
              user={user} />
          )} 
          exact/>

          <Route path={`/survey`} component={(history) => (
            <SurveyContainer 
              history={history} 
              passPortal={passPortal} 
              postBalance={(c, it, ids) => _postBalance(c, it, '', ids)}
              test={test}
              />
            )} exact />

          <Route path={`/avisos`} exact>
            <OcationAds DeviceID={deviceId}  ap={ap}/>
          </Route>
          <Route path={`/avisos/:id`} exact>
            <CategoryItem  ap={ap} DeviceID={deviceId} search={location.search}/>
          </Route>
          <Route path={`/avisos/ad/:id`} exact>
            <OcationContentItem history={history} passPortal={passPortal} postBalance={(c, it) => _postBalance(c, it)} user={user} />
          </Route>

          <Route path={`/podcast`} exact>
            <AudioPodcast history={history} passPortal={passPortal} postBalance={(c, it) => _postBalance(c, it)} user={user}/>
          </Route>


            <Route path={`/reqcredit`} exact>
              <ReqCredit history={history} passPortal={passPortal}/>
            </Route>

            <Route path={`/politicas`} exact>
              <Politicas history={history}/>
            </Route>
{/*------------------ News ---------------------- */}
            
            <Route path="/newdescription" exact>
                <NewDescription passPortal={passPortal}/>
            </Route>
            <Route path="/newcontent" exact>
                <NewContent/>
            </Route>

            <Route path="/adgoogle" exact>
                <GoogleAdsSense/>
            </Route>

      </Switch>

        ) : (
          <div style={{
            color: 'red',
            width: '100%',
            position: 'absolute',
            display: 'flex',
            bottom: '0',
            top: '0',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '25px',
            fontWeight: '500'
          }}>
            <label>AP DOES NOT EXIST</label>
          </div>
        )

      }
    
    </div>
  </Router>
  )

}

export default App;
